import React, { useState } from 'react';
import { cardDetails } from './cardDetails';
import { formatDescription } from '../../utils';

const Accordion = ({ selectedCard }) => {

  const selectedContent = cardDetails[selectedCard]?.content || [];

  // State to track expanded items
  const [expandedItems, setExpandedItems] = useState({});

  // Toggle the expanded state of an item
  const toggleItem = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the state of the clicked item
    }));
  };

  return (
    <div className="accordion" id="accordionExample">
      {selectedContent.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading${index}`}>
            <button
              className={`accordion-button ${expandedItems[index] ? "" : "collapsed"}`} // Add "collapsed" class dynamically
              type="button"
              style={{
                backgroundColor: expandedItems[index] ? "#FFCC19" : "white",
                fontWeight: expandedItems[index] ? "600" : "400",
              }}
              onClick={() => toggleItem(index)} // Toggle the item on click
              aria-expanded={expandedItems[index] ? "true" : "false"}
              aria-controls={`collapse${index}`}
            >
              {item.question}
            </button>
          </h2>
          <div
            id={`collapse${index}`}
            className={`accordion-collapse collapse ${expandedItems[index] ? "show" : ""}`} // Add "show" class if expanded
            aria-labelledby={`heading${index}`}
          >
            <div className="accordion-body">
              {formatDescription(item.answer)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;